<template>
  <div>
    <section id="resume" v-if="data.certificates">
      <div class="section">
        <transition appear @before-enter="beforeEnterH1" @enter="enterH1">
          <h1>{{ "" }}</h1>
        </transition>
        <Diploms
          v-if="data.diploms"
          :diploms="data.diploms"
          :beforeEnterBox="beforeEnterBox"
          :enterBox="enterBox"
          :beforeEnter="beforeEnter"
          :enter="enter"
        />
        <br />
        <Certificates
          v-if="data.certificates"
          :certificates="data.certificates"
          :beforeEnterBox="beforeEnterBox"
          :enterBox="enterBox"
          :beforeEnter="beforeEnter"
          :enter="enter"
        />
        <br />
        <Experiences
          v-if="data.experiences"
          :experiences="data.experiences"
          :beforeEnterBox="beforeEnterBox"
          :enterBox="enterBox"
          :beforeEnter="beforeEnter"
          :enter="enter"
        />
      </div>
    </section>
    <Error
      v-if="error"
      :error="error"
      :beforeEnter="beforeEnter"
      :enter="enter"
    />
  </div>
</template>
<script>
import Experiences from "./resume/Experiences";
import Diploms from "./resume/Diploms";
import Certificates from "./resume/Certificates";
import gsapAnimation from "../composables/gsapAnimation";
import getData from "../composables/getData";
import { Error } from "../components";
export default {
  components: { Diploms, Certificates, Experiences, Error },
  setup() {
    const {
      beforeEnterH1,
      enterH1,
      beforeEnterBox,
      enterBox,
      beforeEnter,
      enter,
    } = gsapAnimation({
      h1: "My Resume",
      y: "-100%",
    });
    const { data, error, fetchData } = getData(process.env.VUE_APP_PROFILE);
    fetchData();
    return {
      beforeEnterH1,
      enterH1,
      beforeEnterBox,
      enterBox,
      beforeEnter,
      enter,
      data,
      error,
      fetchData,
    };
  },
};
</script>
<style>
#resume .section > .certificates > h2,
#resume .section > div > h2 {
  width: fit-content;
  display: inline-block;
  padding: 7px 15px;
  font-size: 18px;
  text-transform: uppercase;
  letter-spacing: 5px;
  font-weight: bold;
  border-radius: 5px;
}
#resume .box {
  background: none;
}
#resume .box div div {
  padding: 1rem 2rem;
  margin: 1rem 0;
  border-radius: 5px;
  background: #fff;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
}
#resume .box div div:nth-child(odd):hover {
  padding-right: 3rem;
}

#resume .box div div:nth-child(even):hover {
  padding-left: 3rem;
}
#resume .box div div:nth-child(odd),
#resume .box div div:nth-child(odd) h2 {
  text-align: right;
}
#resume .box div div:nth-child(odd) p {
  text-align: justify;
}
#resume small {
  color: #bfbfbf;
  font-weight: bold;
}
#resume p {
  margin-top: 1.1rem;
}
@media screen and (max-width: 520px) {
  #resume .section > .certificates > h2,
  #resume .section > div > h2 {
    width: fit-content;
    display: inline-block;
    font-size: 1.2rem;
  }
}
</style>
